module.exports = __webpack_public_path__ + "img/softinya-9-lang.54e6d332.png";